import { css } from '@emotion/react'
import { InputHTMLAttributes, CSSProperties } from 'react'
import { UseFormRegisterReturn } from 'react-hook-form'

type PropsType = {
	title?: string
	name: string
	wrapperStyle?: CSSProperties
	register?: UseFormRegisterReturn
	inputRef?: React.MutableRefObject<HTMLInputElement | null>
} & InputHTMLAttributes<HTMLInputElement>
const InputField = ({ title, name, wrapperStyle, register, inputRef, ...rest }: PropsType) => {
	const titleStyle = css`
		font-family: 'Pretendard';
		font-style: normal;
		font-weight: 500;
		font-size: 1.4rem;
		line-height: 1.7rem;
		letter-spacing: 0.2px;
		margin-bottom: 0.5rem;
	`
	const fieldStyle = css`
		background: #ffffff;
		border: 1px solid #92959e;
		border-radius: 8px;
		box-sizing: border-box;
		padding: 1.3rem 1.9rem;
		width: 100%;
	`
	return (
		<div style={wrapperStyle}>
			<div css={titleStyle}>{title}</div>
			<div>
				<input
					css={fieldStyle}
					type="text"
					name={name}
					{...rest}
					{...register}
					ref={(e) => {
						if (register) {
							register.ref(e)
						}
						if (inputRef) {
							Object.assign(inputRef, { current: e })
						}
					}}
				/>
			</div>
		</div>
	)
}
export default InputField
